import { render, staticRenderFns } from "./SecuritySettingsCard.vue?vue&type=template&id=0f151de6&scoped=true&"
import script from "./SecuritySettingsCard.vue?vue&type=script&lang=js&"
export * from "./SecuritySettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./SecuritySettingsCard.vue?vue&type=style&index=0&id=0f151de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f151de6",
  null
  
)

export default component.exports